import { ApolloError } from '@apollo/client';
import { COOKIE_NAME, setAuthCookies } from '@foxtaibox/foxtailbox-frontend-core';
import { RefreshTokenResponse } from 'config/apolloConfig/fetchRefreshToken';
import { isTelegram, processQueue } from 'config/apolloConfig/index';
import { LoginByTelegramWebAppResponse } from 'config/apolloConfig/webAppLogin';
import ROUTES from 'constants/routes';
import cookies from 'js-cookie';
import { removeItem, setItem } from 'utils/cloudStorage';

export const rejectRefreshToken = async (e: ApolloError | Error | unknown) => {
  await processQueue(e, null);
  // Аналогично ошибкам GQL, если не достучались до сервера вообще, идем на авторизацию
  const TOKENS = [COOKIE_NAME.ACCESS_TOKEN, COOKIE_NAME.REFRESH_TOKEN];
  if (isTelegram) {
    TOKENS.forEach((token) => removeItem(token));
  } else {
    TOKENS.forEach((token) => cookies.remove(token));
  }

  let redirectUrl = '';

  const ROUTES_WITHOUT_REDIRECT = [
    ROUTES.LOGIN,
    ROUTES.CONFIRM_USER_DATA,
    ROUTES.LANGUAGE_SELECT,
    ROUTES.PUBLIC_EXAMINATION,
    ROUTES.EXAMINATION,
    ROUTES.CONFIRM_REGISTER,
    ROUTES.REGISTER,
    ROUTES.PASSWORD_RESET,
    ROUTES.OAUTH,
  ] as string[];
  const isWithoutRedirect = ROUTES_WITHOUT_REDIRECT.includes(window.location.pathname);

  if (!isWithoutRedirect) {
    if (window.location.pathname && window.location.pathname !== '/') {
      redirectUrl += window.location.pathname;
    }

    if (window.location.search) {
      redirectUrl += window.location.search;
    }
  }

  if (!isTelegram) {
    window.location.replace(
      `${ROUTES.LOGIN}${redirectUrl ? `?redirectUrl=${encodeURIComponent(redirectUrl)}` : ''}`,
    );
  }
};

export const resolveRefreshToken = async (
  data: RefreshTokenResponse | LoginByTelegramWebAppResponse | null,
) => {
  if (data?.errors?.length || !data?.data) {
    throw new Error('Error refreshing token');
  }

  let tokens;
  if ('refreshTokens' in data.data) {
    tokens = data.data.refreshTokens;
  } else if ('loginByTelegramWebAppToken' in data.data) {
    tokens = data.data.loginByTelegramWebAppToken;
  } else {
    throw new Error('Invalid token response');
  }
  const { accessToken, refreshToken } = tokens;

  const newCookies = [
    {
      name: COOKIE_NAME.ACCESS_TOKEN,
      value: accessToken,
    },
    {
      name: COOKIE_NAME.REFRESH_TOKEN,
      value: refreshToken,
    },
  ];

  if (isTelegram) {
    newCookies.forEach(({ name, value }) => setItem(name, value));
  } else {
    setAuthCookies(newCookies);
  }

  // Запускаем очередь отклоненных запросов с новым токеном
  await processQueue(null, accessToken);
};
